// extracted by mini-css-extract-plugin
export default {"sticky":"navbar_sticky__DS8Yk","nav_container":"navbar_nav_container__THQEf"};